import { Button, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { Dismiss24Filled, TextAlignJustify24Filled } from '@fluentui/react-icons';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import AppLogoWithTitle from '../Common/AppLogoWithTitle';
import { AppMenuContent } from './AppMenuContent';
import MenuCommands from './MenuCommands';

const menuMobileHeight = '55px';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        height: menuMobileHeight,
        backgroundColor: tokens.colorNeutralBackground1, // Match desktop background
        ...shorthands.overflow('hidden'),
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        backgroundColor: tokens.colorNeutralBackground1, // Match desktop background
        ...shorthands.padding('0', '0.5rem'),
        ...shorthands.gap('1rem'),
        ...shorthands.flex(1),
    },

    contentRoot: {
        display: 'flex',
        flexGrow: '1',
        position: 'absolute',
        top: menuMobileHeight,
        flexDirection: 'column',
        backgroundColor: tokens.colorNeutralBackground1, // Match desktop background
        zIndex: 999,
        width: '100%',
    },
    contentRootClose: {
        height: '0px',
    },
    contentRootOpen: {
        height: `calc(100vh - var(--vh-offset, 0px) - ${menuMobileHeight})`,
    },
    content: {
        display: 'flex',
        flexGrow: '1',
        backgroundColor: tokens.colorNeutralBackground1,
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        ...shorthands.overflow('hidden'),
        ...shorthands.padding('1rem'),
        ...shorthands.transition('height', '0.15s', 'ease-in-out'),
        zIndex: 999,
    },
    contentClose: {
        height: '0px',
        ...shorthands.padding('0px'),
    },
    contentOpen: {
        height: `calc(100vh - var(--vh-offset, 0px) - ${menuMobileHeight})`,
    },
    bottom: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalM,
    },
    smallDivider: {
        flexGrow: 0,
        height: '1.5rem',
    },

    workpsaceCommands: {
        display: 'flex',
        flexDirection: 'row',
        columnGap: '10px',
        justifyContent: 'center',
        maxHeight: '32px',
        ...shorthands.flex(0),
    },
});

interface AppMenuProps {
    onNewChat: (gptConfiguration: IGptConfiguration) => void;
}

const AppMenuMobile: FC<AppMenuProps> = ({onNewChat}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className={mergeClasses(classes.root)}>
            <div className={classes.header}>
                <Button title={t('menu.toggle')} icon={isMenuOpen ? <Dismiss24Filled /> : <TextAlignJustify24Filled />} onClick={handleMenuToggle} />
                <AppLogoWithTitle theme='light'/>
                <div></div>
            </div>

            <div className={mergeClasses(classes.contentRoot, isMenuOpen ? classes.contentRootOpen : classes.contentRootClose)} onClick={handleMenuToggle}>
                <div className={mergeClasses(classes.content, isMenuOpen ? classes.contentOpen : classes.contentClose)} onClick={(ev) => ev.stopPropagation()}>
                    <MenuCommands 
                        onNewChat={onNewChat} 
                        onCloseMenuRequired={() => {
                            setIsMenuOpen(false);
                        }}
                    />
                    <AppMenuContent
                        onCloseMenuRequired={() => {
                            setIsMenuOpen(false);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default AppMenuMobile;
